import React from 'react';
import { AxlInput, AxlPanel, AxlButton, AxlTextArea, AxlCheckbox } from 'axl-reactjs-ui';
import {inject, observer} from "mobx-react";
import Rating from "react-rating";
import {IconButton, Box} from "@material-ui/core";
import {ThumbDown as ThumbDownIcon, ThumbUp as ThumbUpIcon} from "@material-ui/icons";

import styles, * as E from './styles';
import {LoadingOverlay} from "../LoadingOverlay";

@inject('shipmentStore')
@observer
class ShipmentFeedback extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      oldData: {
        stop_id: 0,
        rating: 0,
        comment: '',
        tags: [],
        thumb: null,
      },
      error: '',
    }
  }

  componentDidMount() {
    const {shipmentStore, shipment} = this.props;

    shipmentStore.getShipmentLatestFeedback(shipment.id, res => {
      if (res.data.id) {
        this.setState({oldData: res.data})
      }
    })
  }

  closeWithoutSave = () => {
    const {oldData} = this.state;
    const {shipmentStore, onClose} = this.props;

    shipmentStore.feedbackForm.setData(oldData);
    onClose();
  };

  save = () => {
    const {shipmentStore, onClose, shipment} = this.props;
    this.setState({error: ''});

    shipmentStore.submitFeedback(shipment.id,res => {
      if (!res.ok) {
        this.setState({error: 'Error while submitting feedback. Please try again later!'});
      }
      onClose();
    })
  };

  handleChangeThumb = (value) => {
    this.setState({oldData: {...this.state.oldData, thumb: value}})
    this.props.shipmentStore.feedbackForm.handlerRating('thumb')(value)
  }

  render() {
    const {oldData} = this.state;
    const {shipmentStore} = this.props;
    const {feedbackForm, loadingModal} = shipmentStore;
    const tagValues = [
      "Late due to Driver",
      "Inappropriate behavior",
      "Confirmed delivery",
      "Damaged - Jitsu",
      "Instructions not followed",
      "Delivered to wrong address",
      "Unconfirmed delivery"
    ];

    return <E.Container>
      {loadingModal && <LoadingOverlay color="#887fff" />}
      <E.Inner>
        <E.Row>
          <E.Title>Add Feedback</E.Title>
        </E.Row>
        <E.Row>
          <E.Label>{`Rate:`}</E.Label>
          <E.Content>
            {/*<Rating initialRating={feedbackForm.getField('rating', 0)}*/}
            {/*        onChange={feedbackForm.handlerRating('rating')}*/}
            {/*        emptySymbol={<img alt="empty" src="/assets/images/star-periwinkle-empty.png" />}*/}
            {/*        fullSymbol={<img alt="full" src="/assets/images/star-periwinkle-full.png" />}*/}
            {/*/>*/}
            <Box component="span" px={1}>
              <IconButton size="small" onClick={() => this.handleChangeThumb(true)}>
                <ThumbUpIcon fontSize="small" style={{color: !!oldData.thumb ? '#4abc4e' : undefined}} />
              </IconButton>
            </Box>
            <Box component="span" px={1}>
              <IconButton size="small" onClick={() => this.handleChangeThumb(false)}>
                <ThumbDownIcon fontSize="small" style={{color: oldData.thumb === false ? '#d0021b' : undefined}} />
              </IconButton>
            </Box>
          </E.Content>
        </E.Row>
        <E.Row>
          <E.Label>{`Tags:`}</E.Label>
          <E.Content>
            <AxlPanel>
              <AxlPanel.Row>
                <AxlPanel.Col>
                  {tagValues.slice(0, 4).map((v, i) => <E.Control key={i}>
                    <AxlCheckbox key={i} checked={feedbackForm.arrayContains("tags", v)} onChange={feedbackForm.handlerCheckboxes} name='tags' value={v} theme={`main`} color={`white`}>{v}</AxlCheckbox>
                  </E.Control>)}
                </AxlPanel.Col>
                <AxlPanel.Col>
                  {tagValues.slice(4).map((v, i) => <E.Control key={i} >
                    <AxlCheckbox checked={feedbackForm.arrayContains("tags", v)} onChange={feedbackForm.handlerCheckboxes} name='tags' value={v} theme={`main`} color={`white`}>{v}</AxlCheckbox>
                  </E.Control>)}
                </AxlPanel.Col>
              </AxlPanel.Row>
            </AxlPanel>
          </E.Content>
        </E.Row>
        <E.Row>
          <E.Label>{`Comment:`}</E.Label>
          <E.Content>
            <AxlTextArea onChange={feedbackForm.handlerTextarea} name='comment' value={feedbackForm.getField('comment', '')} placeholder={`Add comment...`} style={styles.textarea} fluid />
          </E.Content>
        </E.Row>
        <E.Row style={styles.noMargin}>
          <E.ButtonContent>
            <AxlButton onClick={this.closeWithoutSave} compact bg={`borBluish`}>{`Cancel`}</AxlButton>
            <AxlButton loading={loadingModal} onClick={this.save} compact bg={`periwinkle`}>{`Submit`}</AxlButton>
          </E.ButtonContent>
        </E.Row>
      </E.Inner>
    </E.Container>
  }
}

export default ShipmentFeedback;